<script>
    export let teachingStartDate = '';
    
    // Separate variables for display (saved) and input (editing)
    let savedStartDate = teachingStartDate || '2025-09-01';
    let inputStartDate = teachingStartDate || '2025-09-01';
    
    // Update both variables when teachingStartDate prop changes
    $: {
        savedStartDate = teachingStartDate || '2025-09-01';
        inputStartDate = teachingStartDate || '2025-09-01';
    }
    
    const submitStartDate = async () => {
        const token = localStorage.getItem('jwtToken');
        
        const formData = {
            start_date: inputStartDate || null,
        };
    
        try {
            const response = await fetch('/studentplayground/update-teaching-start-date/', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
            });
    
            if (!response.ok) {
                throw new Error('Nepavyko išsaugoti datos');
            }
    
            const result = await response.json();
            if (result.success) {
                // Update the saved date only after successful submission
                savedStartDate = inputStartDate;
                alert('Mokymo pradžios data sėkmingai išsaugota!');
            } else {
                alert('Klaida: ' + result.message);
            }
        } catch (error) {
            console.error('Error submitting start date:', error);
            alert('Klaida išsaugant datą');
        }
    };
</script>

<style>
    .form-container {
        width: 100%;
    }

    .form-group {
        margin-bottom: 16px;
        display: flex;
        flex-direction: column;
        width: 60%;
    }

    .form-row {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
    }

    button {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 12px 20px;
        gap: 10px;
        
        height: 45px;
        
        /* White background */
        background-color: white;
        
        /* Black border */
        border: 2px solid #000000;
        
        /* Box shadow */
        box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16);
        
        /* Rounded corners */
        border-radius: 8px;
        
        /* Inside auto layout */
        flex: none;
        order: 0;
        flex-shrink: 0;
        flex-grow: 0;
        
        /* Remove default button styling */
        outline: none;
        cursor: pointer;
        
        /* Remove the default button background on focus */
        background-image: none;
        transition: background-color 0.3s ease, color 0.3s ease;
    }

    /* Button hover effect */
    button:hover {
        background-color: #14695b;
        color: white;
    }

    input {
        padding: 8px;
        border-radius: 6px;
        border: 1px solid #14695b;
    }

    span {
        margin-bottom: 5px;
        font-weight: bold;
    }

    button span {
        font-weight: bolder;
        font-size: larger;
    }

    .current-date-indicator {
        margin-bottom: 16px;
        padding: 12px;
        background-color: #f0f8f5;
        border: 1px solid #14695b;
        border-radius: 6px;
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .current-label {
        font-weight: bold;
        color: #14695b;
    }

    .current-date {
        font-weight: normal;
        color: #333;
        background-color: white;
        padding: 4px 8px;
        border-radius: 4px;
        border: 1px solid #ddd;
    }
</style>

<div class="form-container">
    <h2>Mokymo pradžios data</h2>
    
    <!-- Current date indicator -->
    <div class="current-date-indicator">
        <span class="current-label">Dabartinė pradžios data:</span>
        <span class="current-date">{savedStartDate}</span>
    </div>
    
    <div class="form-row">
        <div class="form-group">
            <span>Pageidaujama pradžios data</span>
            <input type="date" bind:value={inputStartDate} />
        </div>
        
        <button on:click={submitStartDate}>
            <span>Išsaugoti datą</span>
        </button>
    </div>
</div>
